import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {

  constructor(
    private translateService: TranslateService,
  ) {
    translateService.setDefaultLang('pt-BR');
  }

  ngOnInit() {
    // REMOVA todo o bloco 'this.config.setTranslation' daqui
  }

  translate(lang: string) {
    this.translateService.use(lang);
  }
}
